<template>
<!-- eslint-disable max-len -->
<list-page
  name="Event Pool"
  use="_id"
  :display="display"
  page-prefix="/blade/event-pools"
  :fetch="getData"
  :remove="deleteEventPool"
></list-page>
</template>

<script>
import { mapActions } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions([
      'getEventPools',
      'deleteEventPool',
    ]),
    async getData() {
      const [eventPools] =
        await Promise.all([this.getEventPools()]);

      return eventPools;
    },
    display({
      name: eventPoolName,
      updated,
    }) {
      const date = updated && new Date(updated);
      const dateString = date && `(edited ${date.toLocaleDateString()} ${date.toLocaleTimeString()})` || '';
      return `${eventPoolName} ${dateString}`;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/EventPoolsList.vue